import React, { useMemo } from 'react';
import {GLOBAL_SEARCH_SECTION} from '../../../../constants/global-search';
import GlobalSearchFilter from './components/GlobalSearchFilter';
import './styles.css';

const GlobalSearchFilters = props => {
  const { selected, restricted = false, onClick } = props;

  const items = useMemo(
    () =>
      [
        {
          caption: 'All',
          icon: 'all',
          name: GLOBAL_SEARCH_SECTION.ALL,
        },
        {
          caption: 'GoBuyside Network',
          icon: 'gbs',
          name: GLOBAL_SEARCH_SECTION.NETWORK,
        },
        {
          caption: 'My Network',
          icon: 'network',
          name: GLOBAL_SEARCH_SECTION.MY_NETWORK,
        },
        {
          caption: 'Firms',
          icon: 'firms',
          name: GLOBAL_SEARCH_SECTION.FIRM,
        },
        {
          caption: 'Reviews',
          icon: 'reviews',
          name: GLOBAL_SEARCH_SECTION.REVIEW,
        },
        {
          caption: 'Jobs',
          icon: 'jobs',
          name: GLOBAL_SEARCH_SECTION.JOB,
        },
        {
          caption: 'Inbox',
          icon: 'inbox',
          name: GLOBAL_SEARCH_SECTION.INBOX,
        },
      ]
        .filter(
          item =>
            [
              GLOBAL_SEARCH_SECTION.JOB,
              GLOBAL_SEARCH_SECTION.MY_NETWORK,
            ].indexOf(item.name) === -1 || !restricted
        )
        .map((item, index) => (
          <GlobalSearchFilter
            key={index}
            data={item.name === selected ? { ...item, selected: true } : item}
            onClick={onClick}
          />
        )),
    [selected]
  );

  return (
    <div className="global-search-filters">
      <div className="global-search-filters__list">{items}</div>
    </div>
  );
};

export default GlobalSearchFilters;
